/**
 * @file dictionary.component.tsx
 * @description Form-control обертка для работы с UI Dictionary компонентом в react-hook-form с поддержкой объектов
 * @author AI-Generated | Human-Reviewed
 * @created 2025-09-03
 * @updated 2025-09-11
 * @dependencies [react, react-hook-form, @components/ui/data/dictionary, @utils/form-object-helper]
 * @related-files [@components/ui/data/dictionary/dictionary.tsx, @utils/form-object-helper.ts]
 */

import { Dictionary as UIDictionary } from '@components/ui/data/dictionary';
import { Control, Controller } from 'react-hook-form';
import { getSimpleObject } from '@utils/form-object-helper';
import { TBaseObjectDto } from '@src/types';

/**
 * Props для form-control компонента Dictionary с интеграцией react-hook-form
 */
interface IDictionary extends Omit<React.ComponentProps<typeof UIDictionary>, 'onChange' | 'value'> {
    /** Control объект из react-hook-form для управления формой */
    control: Control;
    /** Имя поля в форме */
    name: string;
    /** Тип справочника для инициализации если значение не задано */
    type?: string;
    /** Дополнительный обработчик изменений с именем поля и выбранным объектом */
    onChangeHandler?: (name: string, value: TBaseObjectDto) => void;
}

export const Dictionary = ({ control, name, onChangeHandler, ...props }: IDictionary) => {
    return (
        <Controller
            name={name}
            control={control}
            render={({ field }) => {
                const value = field.value;

                if (!value?.$type && props?.type) {
                    return (
                        <UIDictionary
                            onChange={(value: TBaseObjectDto) => {
                                field.onChange(value);
                                onChangeHandler && onChangeHandler(name, value);
                            }}
                            value={getSimpleObject({ id: '', name: '', $type: props.type })}
                            {...props}
                        />
                    );
                }

                return (
                    <UIDictionary
                        onChange={(value: TBaseObjectDto) => {
                            field.onChange(value);
                            onChangeHandler && onChangeHandler(name, value);
                        }}
                        value={value}
                        {...props}
                    />
                );
            }}
        />
    );
};
